import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchBy'
})
export class SearchByPipe implements PipeTransform {

  transform(values: any, args?: any): any {
    const regExp1 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    const regExp2 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    const regExp = new RegExp(regExp1 + args[1] + regExp2, 'i');
    if (!args[1]) {
      args[1] = '';
    }
    if (values) {
      values = values.filter(
        (value) => {
          for (const arg of args[0]) {
            if (regExp.test(eval('value[arg]'))) {
              return value;
            }
          }
        }
      );
    }
    return values;
  }

}
